import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "content-copier__popup",
  "aria-live": "assertive"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "visually-hidden" }

import { ref } from 'vue';
import CopyIcon from '@src/components/shared/icons/CopyIcon.vue';

interface Props {
	label?: string;
	value: string;
	copyValue?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentCopier',
  props: {
    label: {},
    value: {},
    copyValue: {}
  },
  setup(__props: any) {


const props = __props;
const timerId = ref<number>( null );
const wasJustCopied = ref<boolean>( false );

const onCopy = (): void => {
	try {
		navigator.clipboard.writeText( props.copyValue || props.value );

		wasJustCopied.value = true;

		if ( timerId.value !== null ) {
			window.clearTimeout( timerId.value );
		}

		timerId.value = window.setTimeout( () => {
			wasJustCopied.value = false;
		}, 1000 );

		// eslint-disable-next-line @typescript-eslint/no-unused-vars
	} catch ( err: any ) {
		// Do nothing
	}
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["content-copier", { 'content-copier--copied': wasJustCopied.value }]),
    onClick: onCopy,
    onTouchstart: onCopy
  }, [
    _createElementVNode("span", _hoisted_1, [
      (wasJustCopied.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.$t( 'copy_popup' )), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (__props.label)
      ? (_openBlock(), _createElementBlock("strong", _hoisted_2, _toDisplayString(__props.label) + ":", 1))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(__props.value) + " ", 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t( 'copy_click_message' )), 1),
    _createVNode(CopyIcon)
  ], 34))
}
}

})